import React from 'react';
import styles from './M_InviteItem.module.css';
import A_UserAvatar from '@/components/A_Atoms/A_UserAvatar/A_UserAvatar';
import A_StatusTag from '@/components/A_Atoms/A_StatusTag/A_StatusTag';
import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';
import { CapsuleInvite } from '@/services/capsulesApi';
import cn from 'classnames';

interface M_InviteItemProps {
  invite: CapsuleInvite;
  onReinvite?: (userId: string | number) => void;
  onRemove?: (userId: string | number) => void;
  reinviteTitle?: string;
  removeTitle?: string;
}

export default function M_InviteItem({
  invite,
  onReinvite,
  onRemove,
  reinviteTitle,
  removeTitle,
}: M_InviteItemProps) {
  const getUserName = (user: CapsuleInvite['to_user']) => {
    if (user.first_name || user.last_name) {
      return `${user.first_name || ''} ${user.last_name || ''}`.trim();
    }
    return user.username;
  };

  const getUserAvatar = (user: CapsuleInvite['to_user']) => {
    return user.avatar || undefined;
  };

  return (
    <div className={styles.invite_item}>
      <div className={styles.user_info}>
        <A_UserAvatar
          src={getUserAvatar(invite.to_user)}
          width={40}
          height={40}
        />
        <div className={styles.user_column}>
          <span className={cn(styles.user_name, 'text-p-2')}>
            {getUserName(invite.to_user)}
          </span>
          <span className={cn(styles.user_handle, 'text-p-2')}>
            @{invite.to_user.username}
          </span>
        </div>
      </div>
      <div className={styles.actions_wrapper}>
        <A_StatusTag
          status={
            invite.accepted ? 'accepted' : invite.declined ? 'rejected' : 'sent'
          }
        />
        {!invite.accepted && onReinvite && (
          <button
            className={styles.action_button}
            onClick={() => onReinvite(invite.to_user.id)}
            title={reinviteTitle || 'Отправить повторно'}
          >
            <Q_Icon.ResendIcon width={16} height={16} fill='none' />
          </button>
        )}
        {onRemove && (
          <button
            className={styles.action_button}
            onClick={() => onRemove(invite.to_user.id)}
            title={removeTitle || 'Удалить'}
          >
            <Q_Icon.CrossIcon width={16} height={16} fill='none' />
          </button>
        )}
      </div>
    </div>
  );
}
